export function formatDate(date: Date): string {
  return date.toLocaleDateString('ch-de', {dateStyle: "long"});
}